import React from 'react';

import { User as LegoUser } from 'lego-on-react';

import { useConfig, useUser } from 'client/common/hooks';
import cn from 'utils/cn';

import './index.css';

const cnUser = cn('user2');

export default function User() {
    const config = useConfig();
    const user = useUser();

    return (
        <LegoUser
            name={user.displayName}
            passportHost={config.passportHost}
            uid={user.uid}
            cls={cnUser({ adv: 'yes' })}
            retpath={config.url}
            yu={user.yandexuid}
            />
    );
}
